import { Component, OnInit } from '@angular/core';
import { UnloadGuardService } from '@core/services/unload-guard/unload-guard.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'gestion-stock';

  constructor(private _unloadGuard: UnloadGuardService) {}

  ngOnInit(): void {
    // Active la garde de déchargement (confirmation native + bip) pour toute la session.
    this._unloadGuard.start();
  }
}
